import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { downloadFileFromUrl } from '../../../../utils/helpers/download'
import { getSubdomain } from '../../../../utils/helpers/url'
import { templatesClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'
import { useNavigationWithModalCloser } from '../../../../utils/contexts/NavigationContext'

const MUTATION = gql`
  mutation UpsertTemplateRecord($input: TemplateRecordInput) {
    upsertTemplateRecord(input: $input, forceReload: true) {
      id
      document {
        id
        src
      }
    }
  }
`

const cleanRequest = item =>
  compose(
    pick(['templateId', 'recordId']), //
    assoc('templateId', item.template?.id)
  )(item)

const validate = (form, setErrors) => {
  const errors = [...appendIf(!form.template?.id, { path: ['template'], message: 'Campo obrigatório' })]
  setErrors(errors)
  return errors.length === 0
}

export const useCreateTemplateRecord = () => {
  const { recordId } = useModalData()
  const closeModal = useCloseModal()
  const workspace = getSubdomain()
  const navigate = useNavigationWithModalCloser()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Users'], client: templatesClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest({ ...form, recordId })
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      if (form?.template?.type === 'pdf') {
        navigate(`/pdfs/${form?.template?.id}/${workspace}/${form?.template?.key}/${recordId}`)
      } else {
        return request({ variables: { input } }).then(resp => {
          if (!resp.errors) {
            downloadFileFromUrl(
              resp.data?.upsertTemplateRecord?.document?.src,
              `Documento gerado com o template: ${form.template?.label}`
            )
            closeModal()
          }
        })
      }
    }
  }

  return [handleRequest, state]
}
